// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://nw79streetcra-vendor.aclarian.com',
  appName: 'Northwest 79th Street CRA | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub4b786148f13030e345bd0372c7e8f7af',
  datadogApplicationId: 'dc81943e-7452-4e09-a505-a630f42796d3',
  datadogService: 'Invoicing_N79SC_PROD',
  ApiKey: 'dyNgj7c0Fhs6%T0A',
  env: 'PROD',
  version: packageInfo.version,
};
